import { render, staticRenderFns } from "./mGameResultTable.vue?vue&type=template&id=729e5dde&scoped=true"
import script from "./mGameResultTable.vue?vue&type=script&lang=js"
export * from "./mGameResultTable.vue?vue&type=script&lang=js"
import style0 from "./mGameResultTable.vue?vue&type=style&index=0&id=729e5dde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729e5dde",
  null
  
)

export default component.exports